<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="fas fa-map mr-4"></i>Map</span>
        </h1>
        <main class="h-full" @mouseover="(e) => e.target.focus({ focusVisible: false })">
            <iframe width="100%" height="100%" frameborder="0" :src="'https://www.google.com/maps/embed/v1/place?key='+this.dashboardProps.googleKey+'&q='+this.dashboardData.legacyPackageItem.postcode.replace(' ','+')">
            </iframe>
        </main>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: {
        dashboardData:Object,
        dashboardProps:Object,
    },
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
        a() {
            return true
        }
    },
    mounted() {
    }
}

</script>